// src/services/storageService.js
const storageAPI = window.electronAPI;

const getKeyFileName = (key) => `${key}.json`;

export const getData = async (key) => {
  try {
    if (storageAPI) {
      const data = await storageAPI.readDataFile(getKeyFileName(key));
      return data;
    } else {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : null;
    }
  } catch (error) {
    console.error(`Error reading data for key [${key}]:`, error);
    return null;
  }
};

export const saveData = async (key, data) => {
  try {
    if (storageAPI) {
      await storageAPI.writeDataFile({ fileName: getKeyFileName(key), data: data });
    } else {
      localStorage.setItem(key, JSON.stringify(data));
    }
    
    // ✅ ДОДАЄМО СПОВІЩЕННЯ ПРО УСПІШНЕ ЗБЕРЕЖЕННЯ
    if (typeof window !== 'undefined' && window.showNotification) {
      window.showNotification({
        title: 'Data Saved',
        message: `${key} has been saved successfully`,
        type: 'success'
      });
    }
  } catch (error) {
    console.error(`Error saving data for key [${key}]:`, error);
    
    // ✅ ДОДАЄМО СПОВІЩЕННЯ ПРО ПОМИЛКУ
    if (typeof window !== 'undefined' && window.showNotification) {
      window.showNotification({
        title: 'Save Error',
        message: `Failed to save ${key}: ${error.message}`,
        type: 'error'
      });
    }
  }
};

export const getSessionItem = async (key) => {
    return await getData(key);
};

export const saveSessionItem = async (key, data) => {
    await saveData(key, data);
};

export const removeSessionItem = async (key) => {
    await saveData(key, null);
};

// ✅ ДОДАЄМО ГЛОБАЛЬНУ ФУНКЦІЮ ДЛЯ СПОВІЩЕНЬ
if (typeof window !== 'undefined') {
  window.showNotification = function(notification) {
    // Створюємо власну реалізацію сповіщень
    const notificationEvent = new CustomEvent('customNotification', {
      detail: notification
    });
    window.dispatchEvent(notificationEvent);
    
    // Або використовуємо браузерні сповіщення
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification(notification.title, {
        body: notification.message,
        icon: '/icon-192.png'
      });
    }
  };
}